import React from 'react';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import { Patamar as PatamarType } from 'helper/windx';

interface PatamarProps {
  valor: PatamarType;
  onChange: (valor: PatamarType) => void;
}

const OPCOES: { id: PatamarType; label: string }[] = [
  { id: 'media', label: 'Média Semanal' },
  { id: 'l', label: 'Leve' },
  { id: 'm', label: 'Médio' },
  { id: 'p', label: 'Pesado' },
];

export default function Patamar({ valor, onChange }: PatamarProps) {
  return (
    <Accordion.Item eventKey="patamar">
      <Accordion.Header>
        <TitleSemiBold>Patamar</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        {OPCOES.map((o) => (
          <RadioButton
            key={o.id}
            id={`windx-patamar-${o.id}`}
            name="windx-patamar"
            label={o.label}
            checked={valor === o.id}
            onChange={() => onChange(o.id)}
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
